import { api } from 'utility';
import { getClientListsUrl } from 'URLs';
// Cards
export function getClients(data, params) {
  return api.post(getClientListsUrl(), data, { params }).then((res) => res.data);
}

export default {
  getClients,
};
